import React from 'react';
import { ThreeDotsVertical as AdditionalOptionsIcon } from './Icons';
import { addClassNames } from '../../Functions/Helper/Component';

export default function AdditionalOptions({ options, className }) {
    const [dropdown, setDropdown] = React.useState(false);
    const container = React.useRef(null);
    React.useEffect(() => {
        const handleClick = (e) => {
            setDropdown(container.current && (container.current === e.target || container.current.contains(e.target)));
        }
        document.addEventListener("click", handleClick);
        return () => document.removeEventListener("click", handleClick);
    }, []);
    
    return (
        <div ref={container} className={addClassNames("dropdown-container", !(className && className.includes("left")) && "right", className)}>
            <button
                type="button"
                className="bg-transparent border-0 color-secondary"
                onClick={() => setDropdown(!dropdown)}
            ><AdditionalOptionsIcon/></button>
            <ul className={addClassNames("dropdown-menu",(dropdown?"show" : ""))}>
                {options?.length && options.map((option, idx) => (
                    <li key={idx}>
                        {option === "divider"? (
                            <hr className="dropdown-divider"/>
                        ): option.onClick ? (
                            <button
                                type='button'
                                className={addClassNames("dropdown-item", option.className)}
                                onClickCapture={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    option.onClick(e);
                                    setDropdown(false);
                                }}
                            >{option.label}</button>
                        ): option}
                    </li>
                ))}
            </ul>
        </div>
    )
}